import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ad5b4e38"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "permissions" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-key fa" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_user_pass_form_component = _resolveComponent("user-pass-form-component")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_ComponentNewMenuItem = _resolveComponent("ComponentNewMenuItem")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_form, {
      model: _ctx.userForm,
      rules: _ctx.rules,
      "label-position": "top",
      ref: "form"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_card, {
          shadow: "never",
          class: "app-form-item"
        }, {
          header: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("label.dataUser")), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      prop: "name",
                      label: _ctx.$t('label.name')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.userForm.name,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userForm.name) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      prop: "lastname",
                      label: _ctx.$t('label.lastName')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.userForm.lastName,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userForm.lastName) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      prop: "email",
                      label: 'Email'
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.userForm.email,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.userForm.email) = $event)),
                          modelModifiers: { trim: true }
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      prop: "userName",
                      label: _ctx.$t('label.username')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.userForm.userName,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.userForm.userName) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, {
          shadow: "never",
          class: "app-form-item"
        }, {
          header: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("label.assignRole")), 1)
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('label.assignRole'),
                        prop: "permissions"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.userRole)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.roles,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.roles) = $event)),
                                  multiple: "",
                                  filterable: "",
                                  "allow-create": "",
                                  "default-first-option": "",
                                  "reserve-keyword": false
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userRole, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.id,
                                        label: item.name,
                                        value: item.id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (
            _ctx.userForm.samplingPoints &&
            !_ctx.roles.includes(7) &&
            (_ctx.roles.includes(1) || _ctx.roles.includes(2) || _ctx.roles.includes(3) || _ctx.roles.includes(8))
          )
                ? (_openBlock(), _createBlock(_component_el_row, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('menu.samplingPoints'),
                            prop: "samplingpoints"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.userForm.samplingPoints,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.userForm.samplingPoints) = $event)),
                                multiple: "",
                                filterable: "",
                                "allow-create": "",
                                "default-first-option": "",
                                "reserve-keyword": false,
                                "value-key": "name"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.samplingpoints, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.id,
                                      label: item.name,
                                      value: item
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('label.availableRoutes'),
                        prop: "availableRoutes"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.availableRoutes,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.availableRoutes) = $event)),
                            multiple: "",
                            filterable: "",
                            "allow-create": "",
                            "default-first-option": "",
                            "reserve-keyword": false
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                label: _ctx.$t('Seleccionar todas'),
                                value: null,
                                onClick: _ctx.toggleSelectAll
                              }, null, 8, ["label", "onClick"]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableRoutesList, (route) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: route.value,
                                  label: route.label,
                                  value: route.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('label.aquacorpMember'),
                        prop: "aquacorpMember"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.userForm.aquacorpMember,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.userForm.aquacorpMember) = $event))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.aquacorpMemberOption, (member) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: member.value,
                                  label: member.label,
                                  value: member.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (
            _ctx.userForm.stations &&
            (_ctx.roles.includes(4) || _ctx.roles.includes(5) || _ctx.roles.includes(6)) &&
            !_ctx.roles.includes(7)
          )
                ? (_openBlock(), _createBlock(_component_el_row, { key: 1 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('menu.stations'),
                            prop: "stations"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.userForm.stations,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.userForm.stations) = $event)),
                                multiple: "",
                                filterable: "",
                                "allow-create": "",
                                "default-first-option": "",
                                "reserve-keyword": false,
                                "value-key": "name"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stations, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.id,
                                      label: item.name,
                                      value: item
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, {
          shadow: "never",
          class: "app-form-item"
        }, {
          header: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("label.setLimits")), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      prop: "alertCreationLimit",
                      label: _ctx.$t('label.alertBound')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "number",
                          modelValue: _ctx.userForm.alertCreationLimit,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.userForm.alertCreationLimit) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      prop: "notificationLimit",
                      label: _ctx.$t('label.notifBound')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "number",
                          modelValue: _ctx.userForm.notificationLimit,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.userForm.notificationLimit) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, {
          shadow: "never",
          class: "app-form-item"
        }, {
          header: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("label.changePassword")), 1)
          ]),
          default: _withCtx(() => [
            _hoisted_3,
            _createVNode(_component_el_link, {
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.openDialogPassword())),
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("label.password")), 1)
              ]),
              _: 1
            }),
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createElementVNode("template", null, [
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.showPassDialog,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.showPassDialog) = $event)),
        width: "30%",
        title: _ctx.titleDialog,
        "append-to-body": ""
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.changePassword()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("label.changePassword")), 1)
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_user_pass_form_component, {
            ref: "userPassForm",
            user: _ctx.oldUser
          }, null, 8, ["user"])
        ]),
        _: 1
      }, 8, ["modelValue", "title"])
    ]),
    _createElementVNode("template", null, [
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.visualiceModalMenus,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.visualiceModalMenus) = $event)),
        width: "30%",
        title: _ctx.$t('label.configMenu'),
        "append-to-body": ""
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_el_button, {
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.close()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("btn.cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.configMenuItems()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("btn.accept")), 1)
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          (_ctx.visualiceModalMenus)
            ? (_openBlock(), _createBlock(_component_ComponentNewMenuItem, {
                key: 0,
                ref: "menuDialog",
                menuItemsOld: _ctx.menuItems
              }, null, 8, ["menuItemsOld"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "title"])
    ])
  ], 64))
}